// extracted by mini-css-extract-plugin
module.exports = {"main-container":"parameters__main-container___1zyUM","mainContainer":"parameters__main-container___1zyUM"};